import * as React from 'react';
import { SVGProps } from 'react';

const IconFileDocumentSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M1 4h14V3H1v1ZM1 13h6v-1H1v1ZM15 10H1V9h14v1ZM1 7h14V6H1v1Z" />
  </svg>
);
export default IconFileDocumentSizeS;
